import { useQuery, type QueryClient } from '@tanstack/react-query'

/**
 * Gemeinsame Marke „Strategie geändert um …“ (Einzel-Select, Angebots-Batch, Rückgängig).
 * Der Grundartikel-Block sperrt Starts, solange seine Familiendaten älter als diese Marke sind —
 * auch wenn die Änderung auf einer anderen Seite (Reiter „Angebote“) passiert ist.
 */
export const STRATEGIE_STAND_KEY = ['strategie-geaendert-ab'] as const

/** Nach jeder Strategie-Änderung: Marke setzen, abhängige Daten neu laden. */
export function nachStrategieAenderung(queryClient: QueryClient): void {
  queryClient.setQueryData(STRATEGIE_STAND_KEY, Date.now())
  void queryClient.invalidateQueries({ queryKey: ['rollout-family'] })
  void queryClient.invalidateQueries({ queryKey: ['rollout-status'] })
  void queryClient.invalidateQueries({ queryKey: ['channel-preview'] })
  void queryClient.invalidateQueries({ queryKey: ['strategy-exceptions'] })
}

export function useStrategieGeaendertAb(): number | null {
  const { data } = useQuery<number | null>({
    queryKey: STRATEGIE_STAND_KEY,
    queryFn: () => null,
    enabled: false,
    initialData: null,
    staleTime: Infinity,
    gcTime: Infinity,
  })
  return data ?? null
}
